import { CmsLinkModel, IconModel } from "../models";

export type BaseSportsHamburgerDataComposition = { branchesCache: BranchesCache, cmsLinks: any[] };

/*
    Tests describing the structure of the ouput data should be written first.
    It would be better to split the tests into few suits:
    - base tests related to class and instance structure
    - business logic
    - edge cases
*/

export class BaseSportsHamburgerBlockData {
    branchesCache: BranchesCache;
    cmsLinks: CmsLinkModel[];
    panels: any[];
    adjustPathFunc: Function;
    navigateToCmsLinkHandler: Function;
    pageNavigationConfig: any;
    mapToCmsLinkModelRef: (value: any) => CmsLinkModel;
    closeMenuHandler: Function;

    constructor(provider: BaseSportsHamburgerDataComposition, navHandler: any) {
        this.branchesCache = provider.branchesCache;
        this.adjustPathFunc = navHandler.Navigation.adjustSportsPath;
        this.navigateToCmsLinkHandler = navHandler.navigateTo;
        this.panels = navHandler.Panels;
        this.mapToCmsLinkModelRef = this.mapToCmsLinkModel.bind(this);
        this.pageNavigationConfig = navHandler.Navigation.pageNavigationConfig;
        this.cmsLinks = provider.cmsLinks.map(this.mapToCmsLinkModelRef);
        this.closeMenuHandler = navHandler.CloseLeftNav;
    }

    mapToCmsLinkModel(cmsLink) {
        const panelId = this.getPanelIdFromHref(cmsLink.Href);
        return new CmsLinkModel({
            title: cmsLink.Title,
            href: this.createURL(cmsLink.Href, panelId),
            icon: new IconModel("", cmsLink.IconID),
            handler: this.navigateToCmsLink.bind(this, cmsLink.Href, panelId)
        });
    }

    createURL(href, panelId) {
        if (href && !panelId) {
            return href;
        }
        else {
            return this.adjustPathFunc(href);
        }
    }

    navigateToCmsLink(href, panelId, event) {
        if (panelId && this.panels[panelId]) {
            event && event.preventDefault();
            this.closeMenuHandler();
            this.navigateToCmsLinkHandler(panelId, false, [], href);
        }
    }

    getPanelIdFromHref(href) {
        const hashIndex = href && href.indexOf("#");
        if (hashIndex === 1 && href.length - 1 !== hashIndex) {
            return href.slice(hashIndex + 1).split("#")[0];
        }

        return "";
    }
}